import React, { createContext, useContext, useState, useEffect } from 'react';
import { LoadingController } from '../utils/LoadingController';
import AppLoading from '../components/AppLoading';

const LoadingContext = createContext({ isLoading: false });

export const LoadingProvider: React.FC<React.PropsWithChildren> = ({
  children,
}) => {
  const [isLoading, setLoading] = useState(false);

  useEffect(() => {
    LoadingController.register(setLoading);
    return () => LoadingController.unregister();
  }, []);

  return (
    <LoadingContext.Provider value={{ isLoading }}>
      <AppLoading hidden={!isLoading} />
      {children}
    </LoadingContext.Provider>
  );
};

export const useLoading = () => useContext(LoadingContext);
